import NBType from '@netbase/nb-type'
import FilterSchema from './FilterSchema'
import NodSentenceInfoSchema from './NodSentenceInfoSchema'
import Precision from '../enums/Precision'
import PreviewTopicSchema from './PreviewTopicSchema'
import SentenceInfoSchema from './SentenceInfoSchema'

/**
 * @typedef {import('./FilterSchema').Filter} Filter
 * @typedef {import('./NodSentenceInfoSchema').NodSentenceInfo} NodSentenceInfo
 * @typedef {import('../enums/Precision').Precision} Precision
 * @typedef {import('./PreviewTopicSchema').PreviewTopic} PreviewTopic
 * @typedef {import('./SentenceInfoSchema').SentenceInfo} SentenceInfo
 */

/**
 * @typedef {object} ParamSchema
 * @property {number[]} analysisIds
 * @property {number[]} comparedTopicIds
 * @property {string[]} documentIds
 * @property {Filter} filter
 * @property {NodSentenceInfo[]} nodSentenceInfos
 * @property {boolean} notMatching
 * @property {Precision} precision
 * @property {boolean} projected
 * @property {number} searchId
 * @property {SentenceInfo[]} sentenceInfos
 * @property {number[]} topicIds
 * @property {PreviewTopic} topicOnTheFly
 * @property {string[]} topics
 */
const ParamSchema = NBType.object().shape('ParamSchema', {
  /* @prop */
  analysisIds: NBType.array().of(NBType.number()),
  /* @prop */
  comparedTopicIds: NBType.array().of(NBType.number()),
  /* @prop */
  documentIds: NBType.array().of(NBType.string()),
  /* @prop */
  filter: FilterSchema,
  /* @prop */
  nodSentenceInfos: NBType.array().of(NodSentenceInfoSchema),
  /* @prop */
  notMatching: NBType.boolean(),
  /* @prop */
  precision: NBType.enum(Precision),
  /* @prop */
  projected: NBType.boolean(),
  /* @prop */
  searchId: NBType.number(),
  /* @prop */
  sentenceInfos: NBType.array().of(SentenceInfoSchema),
  /* @prop */
  topicIds: NBType.array().of(NBType.number()),
  /* @prop */
  topicOnTheFly: PreviewTopicSchema,
  /* @prop */
  topics: NBType.array().of(NBType.string())
  /* END */
})
export default ParamSchema
// RESERVE BELOW
